import { useContext } from 'react';
import I18n from 'I18n';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { And, Or } from '../../filterQueryFormat/logic/FilterLogicGroup';
import UISelect from 'UIComponents/input/UISelect';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { useOnChangeHandlers } from '../../hooks/useOnChangeHandlers';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const TopLevelLogicGroupToggle = () => {
  const {
    internalDraftValue,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    handleOnChange
  } = useOnChangeHandlers();
  const getTopLevelLogicGroup = () => {
    return (internalDraftValue === null || internalDraftValue === void 0 ? void 0 : internalDraftValue.logicGroupName) || LogicGroupNames.OR;
  };
  const handleTopLevelLogicGroupChange = e => {
    const newLogicGroupName = e.target.value;
    if (internalDraftValue) {
      const newInternalDraftValue = newLogicGroupName === LogicGroupNames.AND ? And.ofRoot().merge(internalDraftValue.set('logicGroupName', newLogicGroupName)) : Or.ofRoot().merge(internalDraftValue.set('logicGroupName', newLogicGroupName));
      dispatch({
        type: 'internalDraftValue',
        payload: newInternalDraftValue
      });
      handleOnChange(newInternalDraftValue);
    }
  };
  const selector = /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": "fr-top-level-logic-group-toggle",
    value: getTopLevelLogicGroup(),
    onChange: handleTopLevelLogicGroupChange,
    options: [{
      value: LogicGroupNames.OR,
      text: I18n.text(`newCustomerDataFilters.topLevelLogicGroupSelection.SelectorOr`)
    }, {
      value: LogicGroupNames.AND,
      text: I18n.text(`newCustomerDataFilters.topLevelLogicGroupSelection.SelectorAnd`)
    }],
    buttonUse: "transparent"
  });
  return /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      className: "m-bottom-4",
      message: "newCustomerDataFilters.topLevelLogicGroupSelection.Selector",
      options: {
        selector
      }
    })
  });
};
export default TopLevelLogicGroupToggle;